// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import EditButton from 'app/components/commons/button/editButton/EditButton';
import ChangeStatusButton from 'app/components/commons/button/changeStatusButton/ChangeStatusButton';
import DefaultPopup from 'app/components/commons/button/defaultPopup/DefaultPopup';
//stylesheet
import styles from './ControlButtons.module.scss';

function ControlButtons(props) {
  const {
    entity,
    onClickEdit,
    disabledEdit,
    onChangeStatus,
    disalbedChangeStatus,
    isChangeStatusActive
    //
  } = props;

  return (
    <div className={styles.controlButtons}>
      <DefaultPopup tag='Editar'>
        <EditButton
          entity={entity}
          onClickEdit={onClickEdit}
          disabled={disabledEdit}
          //
        />
      </DefaultPopup>

      <DefaultPopup tag={isChangeStatusActive ? 'Desativar' : 'Ativar'}>
        <ChangeStatusButton
          entity={entity}
          onChangeStatus={onChangeStatus}
          disabled={disalbedChangeStatus}
          isActive={isChangeStatusActive}
        />
      </DefaultPopup>
    </div>
  );
}

ControlButtons.defaultProps = {
  isChangeStatusActive: true,
  disabledEdit: false,
  onClickEdit: () => {},
  disalbedChangeStatus: false,
  onChangeStatus: () => {}
};

ControlButtons.propTypes = {
  isChangeStatusActive: PropTypes.bool,
  entity: PropTypes.object,
  onClickEdit: PropTypes.func,
  disabledEdit: PropTypes.bool,
  entityChangeStatus: PropTypes.object,
  onChangeStatus: PropTypes.func,
  disalbedChangeStatus: PropTypes.bool
};

export default ControlButtons;
